import angular from 'angular';
import phoneIconField from './phoneIconField';
import './style.scss';

export default angular
  .module('phoneIconField', [])
  .component('phoneIconField', phoneIconField).name;
